import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  FiCalendar,
  FiClock,
  FiGift,
  FiHeart,
  FiMapPin,
  FiMusic,
  FiPause,
  FiPlay,
  FiUsers,
  FiX,
} from 'react-icons/fi';
import heroDesktop from '../../../assets/images/claudia-eve/claudia-care-rainbow-desktop.webp';
import heroMobile from '../../../assets/images/claudia-eve/claudia-care-rainbow-mobile.webp';
import celebrantCover from '../../../assets/images/claudia-eve/celebrant-photo-cover-photo.jpg';
import celebrantCoverMobile from '../../../assets/images/claudia-eve/celebrant-photo-cover-photo-mobile.jpg';
import celebrantCareBears from '../../../assets/images/claudia-eve/celebrant-photo.jpg';
import celebrantPortrait from '../../../assets/images/claudia-eve/celebrant-photo (2).jpg';
import celebrantGarden from '../../../assets/images/claudia-eve/celebrant-photo (3).jpg';
import bgMusic from '../../../assets/sounds/claudia-care-bears-sparkle.mp3';
import venuePhoto from '../../../assets/images/claudia-eve/venue-preview.webp';
import logicaLogo from '../../../assets/images/Logica (Black and White).webp';
const INVITATION_ID = 'claudia-eve-polidario-7th-birthday';
const INVITATION_TITLE = "Claudia Eve's 7th Birthday";

const EVENT_DATE = new Date('2026-07-06T17:00:00+08:00');
const EVENT_DATE_LABEL = 'Monday, July 6, 2026';
const EVENT_TIME_LABEL = '5:00 PM';
const VENUE_NAME = 'Vikings Eastwood Mall';
const VENUE_ADDRESS = 'Eastwood Mall, Quezon City';
const VENUE_MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=Vikings%20Eastwood%20Mall';

const entourageGroups = [
  {
    title: '7 Candles',
    note: 'Lighting up Claudia Eve with love',
    names: [
      'Charlotte Ofelia Urieta',
      'Athena Kenn Teodoro',
      'Leinah Kassandra Soco',
      'Jana Celestine Quejong',
      'Selah Bethia Lacsa',
      'Jeon Caelen Tesalona',
      'Alexandra Santos',
    ],
  },
  {
    title: '7 Wishes',
    note: 'Blessings for a bright new year',
    names: [
      'Cheina Baquiran',
      'Frances Polidario',
      'Marose Polidario',
      'Cherlyn Baquiran',
      'Monique Baquiran',
      'Ericka Soco',
      'Ariane Teodoro',
    ],
  },
  {
    title: '7 Treasures',
    note: 'Gifts of care and happy memories',
    names: [
      'Jeffrey Creus',
      'Ariel David',
      'Christian Cruz',
      'Annlyn Josue',
      'Candy Morales',
      'Richmond Manuel',
      'Argie Memoracion',
    ],
  },
  {
    title: '7 Flowers',
    note: 'Sweet blooms for our birthday girl',
    names: [
      'Manuel Polidario',
      'Chester Baquiran',
      'Jhiro Gaza',
      'Gab Polidario',
      'Franco Polidario',
      'Chance Fino Urieta',
      'Charles Urieta',
    ],
  },
];

const reminders = [
  {
    title: 'Guest Arrival',
    text: 'Please arrive by 5:00 PM so everyone can settle in before the celebration begins.',
  },
  {
    title: 'Dress Code',
    text: 'Pastel colors only, please. No dark-colored outfits.',
  },
  {
    title: 'Seating',
    text: 'Seats will be arranged at the venue by the family.',
  },
];

const glimpsePhotos = [
  {
    src: celebrantCareBears,
    alt: 'Claudia Eve smiling with pastel Care Bears plush toys',
    className: 'ce-glimpse-tall',
  },
  {
    src: celebrantCover,
    alt: 'Claudia Eve in a lavender dress on a floral swing',
    className: 'ce-glimpse-wide',
  },
  {
    src: celebrantPortrait,
    alt: 'Claudia Eve in a pink pastel birthday dress',
    className: 'ce-glimpse-tall',
  },
];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@500;600;700;800&family=Inter:wght@400;500;600;700;800&family=Playfair+Display:wght@700;800&display=swap');

* { box-sizing: border-box; }
html, body { overflow-x: hidden; }
button, input, select, textarea { font: inherit; }

.ce-page {
  min-height: 100vh;
  color: #40235f;
  background:
    radial-gradient(circle at 12% 10%, rgba(255, 190, 216, .48), transparent 30%),
    radial-gradient(circle at 92% 18%, rgba(155, 220, 255, .46), transparent 28%),
    linear-gradient(180deg, #fff8fc 0%, #f7fbff 48%, #fff8ee 100%);
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
}

.ce-page::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    radial-gradient(circle, rgba(255, 255, 255, .72) 0 2px, transparent 3px),
    radial-gradient(circle, rgba(255, 201, 108, .36) 0 1px, transparent 2px);
  background-size: 54px 54px, 34px 34px;
  mask-image: linear-gradient(180deg, #000 0%, transparent 92%);
  opacity: .6;
  z-index: 0;
}

.ce-shell {
  position: relative;
  z-index: 1;
}

.ce-opening {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  align-items: center;
  justify-items: center;
  padding: 24px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, .18), rgba(255, 255, 255, .76)),
    url('${heroMobile}') center / cover no-repeat;
  transition: opacity .7s ease, transform .7s ease;
}

.ce-opening::before {
  content: '';
  position: absolute;
  pointer-events: none;
  z-index: 0;
}

.ce-opening::before {
  inset: 0;
  background:
    radial-gradient(circle at 22% 18%, rgba(255, 141, 188, .16), transparent 26%),
    radial-gradient(circle at 82% 12%, rgba(139, 217, 255, .18), transparent 28%),
    linear-gradient(180deg, rgba(255, 255, 255, .06), rgba(255, 255, 255, .28));
  opacity: .9;
  animation: ceOpeningGlow 5.5s ease-in-out infinite;
}

.ce-opening.is-leaving {
  opacity: 0;
  transform: scale(1.03);
  pointer-events: none;
}

.ce-opening-particles {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.ce-wish-particle {
  position: absolute;
  left: var(--left);
  bottom: -24px;
  width: var(--size);
  height: var(--size);
  color: var(--color);
  opacity: 0;
  animation: ceWishFloat var(--duration) ease-in-out infinite;
  animation-delay: var(--delay);
}

.ce-wish-particle::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: currentColor;
  clip-path: var(--shape);
  filter: drop-shadow(0 5px 10px rgba(139, 92, 246, .12));
}

.ce-opening-card {
  position: relative;
  z-index: 1;
  width: min(100%, 350px);
  text-align: center;
  padding: 28px 22px 26px;
  border: 1px solid rgba(255, 255, 255, .72);
  border-radius: 28px;
  background: rgba(255, 255, 255, .78);
  box-shadow: 0 24px 66px rgba(118, 92, 173, .2);
  backdrop-filter: blur(14px);
  animation: ceCardIn .75s cubic-bezier(.2, .9, .2, 1) both;
  overflow: hidden;
}

.ce-opening-card::before {
  content: '';
  position: absolute;
  inset: 10px;
  border-radius: 24px;
  border: 1px dashed rgba(226, 114, 170, .22);
  pointer-events: none;
  z-index: 0;
}

.ce-opening-age,
.ce-age-badge {
  width: 70px;
  height: 70px;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  font-family: 'Baloo 2', cursive;
  font-size: 40px;
  font-weight: 800;
  background:
    linear-gradient(135deg, #ff8dbc, #a98bff 52%, #71ccff),
    #c28cff;
  box-shadow: 0 14px 28px rgba(176, 118, 220, .3), inset 0 0 0 5px rgba(255, 255, 255, .38);
}

.ce-opening-age {
  animation: ceAgePop .72s cubic-bezier(.18, 1.45, .5, 1) both, ceAgeBob 2.8s ease-in-out .8s infinite;
}

.ce-opening-title {
  margin: 16px 0 4px;
  font-family: 'Playfair Display', serif;
  font-size: clamp(44px, 12vw, 62px);
  line-height: .92;
  color: #8b54dd;
  text-shadow: 0 7px 0 rgba(255, 255, 255, .78);
}

.ce-opening-sub {
  margin: 0 0 22px;
  color: #624071;
  font-weight: 700;
  font-size: 18px;
}

.ce-btn {
  min-height: 60px;
  min-width: 206px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 0 28px;
  color: #fff;
  background: linear-gradient(100deg, #e564ad 0%, #9c71f4 56%, #66c4ff 100%);
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -.01em;
  cursor: pointer;
  box-shadow: 0 14px 26px rgba(151, 99, 224, .26);
  transition: transform .2s ease, box-shadow .2s ease;
}

.ce-btn:hover { transform: translateY(-2px) scale(1.02); box-shadow: 0 18px 34px rgba(158, 109, 218, .32); }
.ce-btn:disabled { cursor: not-allowed; opacity: .62; transform: none; }
.ce-btn.secondary {
  color: #7251a3;
  background: rgba(255, 255, 255, .76);
  border: 1px solid rgba(155, 118, 204, .22);
}

.ce-music {
  position: fixed;
  right: 16px;
  top: 16px;
  z-index: 20;
  display: flex;
  gap: 8px;
}

.ce-icon-btn {
  width: 46px;
  height: 46px;
  border: 1px solid rgba(255, 255, 255, .7);
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #7649b8;
  background: rgba(255, 255, 255, .72);
  box-shadow: 0 12px 30px rgba(118, 92, 173, .16);
  backdrop-filter: blur(10px);
  cursor: pointer;
}

.ce-hero {
  min-height: 100svh;
  padding: 88px clamp(16px, 4vw, 46px) 26px;
  display: grid;
  align-items: end;
  position: relative;
  overflow: hidden;
}

.ce-hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.ce-hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 62%;
}

.ce-hero-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, .86) 0%, rgba(255, 255, 255, .66) 38%, rgba(255, 255, 255, .08) 76%),
    linear-gradient(180deg, rgba(49, 24, 77, .1) 0%, rgba(49, 24, 77, .08) 44%, rgba(49, 24, 77, .52) 100%);
}

.ce-hero-inner {
  position: relative;
  z-index: 1;
  width: min(100%, 1160px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  text-align: left;
}

.ce-hero-panel {
  width: min(100%, 620px);
  margin: 0;
  padding: 0;
  border-radius: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
}

.ce-eyebrow {
  margin: 0 0 14px;
  color: #d25d94;
  font-size: clamp(11px, 2.4vw, 13px);
  font-weight: 900;
  letter-spacing: .26em;
  text-transform: uppercase;
}

.ce-hero-title {
  margin: 10px 0 10px;
  font-family: 'Playfair Display', serif;
  font-size: clamp(54px, 14vw, 128px);
  line-height: .88;
  color: #8d63df;
  text-shadow: 0 8px 0 rgba(255, 255, 255, .72), 0 18px 38px rgba(73, 39, 104, .18);
}

.ce-hero-title span {
  display: block;
  color: #f26b9f;
}

.ce-hero-subtitle {
  margin: 0;
  width: min(100%, 540px);
  color: #5d4071;
  font-family: 'Baloo 2', cursive;
  font-size: clamp(22px, 5.5vw, 38px);
  font-weight: 800;
  line-height: 1.05;
}

.ce-hero-copy {
  margin: 16px 0 0;
  width: min(100%, 560px);
  color: #634d73;
  font-size: clamp(15px, 2.6vw, 17px);
  line-height: 1.72;
  font-weight: 600;
}

.ce-hero-actions {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
}

.ce-hero-meta {
  width: min(100%, 760px);
  margin: 14px 0 0;
  color: #523866;
  font-family: 'Baloo 2', cursive;
  font-size: clamp(16px, 2.4vw, 22px);
  font-weight: 800;
  line-height: 1.25;
  text-shadow: 0 2px 12px rgba(255, 255, 255, .86);
}

.ce-hero-meta span {
  color: #f0649d;
  padding: 0 8px;
}

.ce-section {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: clamp(42px, 7vw, 82px) clamp(16px, 4vw, 34px);
}

.ce-section-head {
  text-align: center;
  margin: 0 auto 24px;
  width: min(100%, 720px);
}

.ce-section-kicker {
  margin: 0 0 8px;
  color: #df6c9f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: .22em;
  text-transform: uppercase;
}

.ce-section-title {
  margin: 0;
  color: #8058c9;
  font-family: 'Baloo 2', cursive;
  font-size: clamp(32px, 7vw, 56px);
  line-height: 1.02;
}

.ce-section-copy {
  margin: 10px auto 0;
  color: #694d75;
  line-height: 1.7;
  font-weight: 600;
}

.ce-cloud-card {
  --cloud-radius: 48px 68px 52px 72px / 58px 48px 66px 52px;
  --cloud-position: center;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: var(--cloud-radius);
  border: 1px solid rgba(255, 255, 255, .82);
  background:
    linear-gradient(90deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .18) 18%, rgba(255, 255, 255, .16) 82%, rgba(245, 246, 255, .86)),
    linear-gradient(135deg, rgba(255, 255, 255, .42), rgba(255, 255, 255, .12)),
    linear-gradient(135deg, rgba(255, 255, 255, .88), rgba(238, 245, 255, .72));
  box-shadow:
    0 28px 68px rgba(115, 90, 168, .16),
    0 8px 22px rgba(130, 189, 230, .1),
    inset 0 1px 0 rgba(255, 255, 255, .92);
  backdrop-filter: blur(12px);
}

.ce-cloud-card::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  border-radius: inherit;
  background:
    radial-gradient(circle at 8% 8%, rgba(255, 255, 255, .76) 0 8%, transparent 19%),
    radial-gradient(circle at 92% 86%, rgba(190, 220, 255, .2) 0 10%, transparent 23%);
}

.ce-details-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.ce-detail {
  --cloud-radius: 44px 58px 48px 62px / 52px 44px 60px 46px;
  min-height: 166px;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
}

.ce-detail:nth-child(2) {
  --cloud-radius: 62px 42px 66px 48px / 46px 58px 44px 62px;
  --cloud-position: 42% center;
}

.ce-detail:nth-child(3) {
  --cloud-radius: 48px 70px 42px 58px / 62px 46px 56px 44px;
  --cloud-position: 62% center;
}

.ce-detail:nth-child(4) {
  --cloud-radius: 66px 50px 58px 42px / 44px 64px 48px 58px;
  --cloud-position: 78% center;
}

.ce-detail::before {
  content: '';
  position: absolute;
  inset: -35% -20% auto auto;
  width: 118px;
  height: 118px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .58);
}

.ce-detail-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  color: #fff;
  background: linear-gradient(135deg, #ff80b3, #9d88ff);
  box-shadow: 0 12px 22px rgba(177, 116, 214, .22);
}

.ce-detail-label {
  margin: 18px 0 4px;
  color: #9b78a9;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .16em;
  text-transform: uppercase;
}

.ce-detail-value {
  margin: 0;
  color: #4d3460;
  font-family: 'Baloo 2', cursive;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.08;
}

.ce-detail-note {
  margin: 6px 0 0;
  color: #755c81;
  font-size: 13px;
  line-height: 1.42;
  font-weight: 600;
}

.ce-countdown {
  --cloud-radius: 72px 52px 78px 58px / 54px 76px 52px 68px;
  --cloud-position: center 58%;
  padding: clamp(22px, 4vw, 34px);
  display: grid;
  grid-template-columns: .85fr 1.15fr;
  gap: 22px;
  align-items: center;
}

.ce-countdown-title {
  margin: 0;
  color: #8058c9;
  font-family: 'Baloo 2', cursive;
  font-size: clamp(30px, 5vw, 48px);
  line-height: 1.02;
}

.ce-countdown-text {
  margin: 8px 0 0;
  color: #6c5279;
  line-height: 1.65;
  font-weight: 600;
}

.ce-countdown-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.ce-time-box {
  min-height: 100px;
  display: grid;
  place-items: center;
  padding: 12px 8px;
  border-radius: 22px;
  color: #fff;
  background: linear-gradient(160deg, #ff8dbc, #a689ff);
  box-shadow: inset 0 0 0 4px rgba(255, 255, 255, .24);
}

.ce-time-num {
  font-family: 'Baloo 2', cursive;
  font-size: clamp(30px, 5vw, 46px);
  font-weight: 800;
  line-height: .85;
}

.ce-time-label {
  font-size: 10px;
  font-weight: 900;
  letter-spacing: .16em;
  text-transform: uppercase;
}

.ce-venue {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, .82fr);
  gap: 18px;
  align-items: stretch;
}

.ce-venue-card {
  --cloud-radius: 64px 46px 74px 52px / 48px 68px 54px 72px;
  --cloud-position: 34% center;
  padding: clamp(24px, 4vw, 36px);
}

.ce-venue-name {
  margin: 0;
  color: #7b55c7;
  font-family: 'Baloo 2', cursive;
  font-size: clamp(34px, 6vw, 58px);
  line-height: 1;
}

.ce-venue-address,
.ce-venue-body {
  color: #624c70;
  line-height: 1.72;
  font-weight: 600;
}

.ce-venue-address { margin: 12px 0 0; }
.ce-venue-body { margin: 18px 0 0; }

.ce-reminders {
  --cloud-radius: 46px 70px 52px 76px / 66px 48px 72px 54px;
  --cloud-position: 72% center;
  padding: 24px;
  display: grid;
  gap: 12px;
}

.ce-reminder {
  padding: 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, .64);
  border: 1px solid rgba(159, 127, 207, .18);
}

.ce-reminder h3 {
  margin: 0 0 5px;
  color: #d56398;
  font-family: 'Baloo 2', cursive;
  font-size: 22px;
  line-height: 1.05;
}

.ce-reminder p {
  margin: 0;
  color: #684f75;
  line-height: 1.55;
  font-size: 14px;
  font-weight: 600;
}

.ce-swatch-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.ce-swatch {
  min-width: 88px;
  padding: 10px 12px;
  border-radius: 999px;
  color: #56386a;
  background: var(--swatch);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, .5);
  font-size: 12px;
  font-weight: 900;
  text-align: center;
}

.ce-entourage-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.ce-glimpse-grid {
  display: grid;
  grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr) minmax(0, .9fr);
  grid-auto-rows: 220px;
  gap: 14px;
}

.ce-glimpse-card {
  margin: 0;
  position: relative;
  overflow: hidden;
  border-radius: 30px;
  background: rgba(255, 255, 255, .72);
  border: 7px solid rgba(255, 255, 255, .7);
  box-shadow:
    0 24px 60px rgba(132, 104, 178, .16),
    inset 0 0 0 1px rgba(255, 255, 255, .34);
}

.ce-glimpse-card[role='button'] {
  cursor: zoom-in;
  transition: transform .22s ease, box-shadow .22s ease;
}

.ce-glimpse-card[role='button']:hover,
.ce-glimpse-card[role='button']:focus-visible {
  transform: translateY(-4px);
  box-shadow:
    0 30px 74px rgba(132, 104, 178, .22),
    inset 0 0 0 1px rgba(255, 255, 255, .42);
}

.ce-glimpse-card[role='button']:focus-visible {
  outline: 3px solid rgba(242, 107, 159, .54);
  outline-offset: 5px;
}

.ce-glimpse-card::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    linear-gradient(180deg, transparent 58%, rgba(98, 62, 122, .22)),
    radial-gradient(circle at 18% 16%, rgba(255, 255, 255, .24), transparent 38%);
}

.ce-glimpse-card img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform .45s ease;
}

.ce-glimpse-card:hover img {
  transform: scale(1.035);
}

.ce-photo-viewer {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  padding: clamp(14px, 3vw, 34px);
  background: rgba(54, 34, 76, .58);
  backdrop-filter: blur(12px);
}

.ce-photo-viewer-card {
  position: relative;
  width: min(100%, 940px);
  max-height: min(86svh, 860px);
  display: grid;
  overflow: hidden;
  border: 8px solid rgba(255, 255, 255, .86);
  border-radius: 30px;
  background: rgba(255, 255, 255, .9);
  box-shadow: 0 34px 90px rgba(44, 24, 64, .28);
}

.ce-photo-viewer-card img {
  width: 100%;
  max-height: calc(86svh - 16px);
  display: block;
  object-fit: contain;
  background: #fff;
}

.ce-photo-viewer-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
}

.ce-glimpse-tall {
  grid-row: span 2;
}

.ce-glimpse-wide {
  grid-column: span 1;
  grid-row: span 2;
}

.ce-glimpse-tall img {
  object-position: center 68%;
}

.ce-glimpse-wide img {
  object-position: center center;
}

.ce-entourage-card {
  --cloud-radius: 54px 42px 62px 48px / 44px 64px 46px 68px;
  padding: 22px 18px;
  position: relative;
  overflow: hidden;
}

.ce-entourage-card:nth-child(2) {
  --cloud-radius: 42px 68px 48px 60px / 62px 46px 66px 50px;
  --cloud-position: 35% center;
}

.ce-entourage-card:nth-child(3) {
  --cloud-radius: 70px 48px 58px 42px / 48px 68px 52px 62px;
  --cloud-position: 65% center;
}

.ce-entourage-card:nth-child(4) {
  --cloud-radius: 48px 62px 44px 72px / 68px 50px 62px 46px;
  --cloud-position: 82% center;
}

.ce-entourage-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 8px;
  background: linear-gradient(90deg, #ff9fbd, #ffe28a, #95e3c2, #8fd8ff, #c8a3ff);
}

.ce-entourage-card h3 {
  margin: 8px 0 4px;
  color: #8058c9;
  font-family: 'Baloo 2', cursive;
  font-size: 27px;
  line-height: 1;
}

.ce-entourage-card p {
  margin: 0 0 14px;
  color: #937aa0;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 700;
}

.ce-name-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 9px;
}

.ce-name-list li {
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 14px;
  color: #533966;
  background: rgba(255, 255, 255, .64);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.25;
}

.ce-name-list li::before {
  content: '';
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff85b3, #90dcff);
}

.ce-footer {
  padding: 26px 16px 42px;
  text-align: center;
  color: #7a5e86;
  font-weight: 700;
}

.ce-footer strong {
  color: #d75d98;
}

.ce-logica-credit {
  width: fit-content;
  margin: 28px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(128, 88, 201, .16);
  display: grid;
  justify-items: center;
  gap: 8px;
}

.ce-logica-credit p {
  margin: 0;
  color: #8a7496;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
}

.ce-logica-heart {
  color: #ef6f9f;
}

.ce-logica-brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #7655a2;
  text-decoration: none;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  transition: opacity .2s ease, transform .2s ease;
}

.ce-logica-brand:hover {
  opacity: .78;
  transform: translateY(-1px);
}

.ce-logica-brand img {
  width: 34px;
  height: 24px;
  display: block;
  object-fit: contain;
  opacity: .68;
}

.ce-float {
  position: absolute;
  z-index: 0;
  width: var(--size);
  height: var(--size);
  left: var(--left);
  top: var(--top);
  opacity: var(--opacity);
  animation: ceFloat var(--duration) ease-in-out infinite alternate;
  animation-delay: var(--delay);
  pointer-events: none;
}

.ce-float::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: var(--color);
  clip-path: var(--shape);
}

@keyframes ceFloat {
  from { transform: translate3d(0, 0, 0) rotate(-5deg); }
  to { transform: translate3d(0, -20px, 0) rotate(8deg); }
}

@keyframes ceOpeningGlow {
  0%, 100% { opacity: .74; }
  50% { opacity: 1; }
}

@keyframes ceWishFloat {
  0% {
    opacity: 0;
    transform: translate3d(0, 0, 0) rotate(-8deg) scale(.82);
  }
  12% { opacity: var(--opacity); }
  78% { opacity: var(--opacity); }
  100% {
    opacity: 0;
    transform: translate3d(var(--drift), -112vh, 0) rotate(18deg) scale(1.08);
  }
}

@keyframes ceCardIn {
  from { opacity: 0; transform: translateY(18px) scale(.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes ceAgePop {
  0% { opacity: 0; transform: scale(.4) rotate(-10deg); }
  70% { opacity: 1; transform: scale(1.12) rotate(3deg); }
  100% { opacity: 1; transform: scale(1) rotate(0); }
}

@keyframes ceAgeBob {
  0%, 100% { transform: translateY(0) rotate(0); }
  50% { transform: translateY(-7px) rotate(2deg); }
}

@media (min-width: 760px) {
  .ce-opening {
    background:
      linear-gradient(180deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .76)),
      url('${heroDesktop}') center / cover no-repeat;
  }
}

@media (max-width: 980px) {
  .ce-details-grid,
  .ce-entourage-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ce-glimpse-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 240px;
  }

  .ce-glimpse-wide {
    grid-column: span 2;
    grid-row: span 1;
  }

  .ce-countdown,
  .ce-venue {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .ce-music {
    right: 12px;
    top: 12px;
  }

  .ce-icon-btn {
    width: 42px;
    height: 42px;
  }

  .ce-hero {
    min-height: 100svh;
    padding: 74px 14px 24px;
  }

  .ce-hero-bg img {
    object-position: center;
  }

  .ce-hero-bg::after {
    background:
      linear-gradient(180deg, rgba(255, 255, 255, .06) 0%, rgba(255, 255, 255, .18) 38%, rgba(255, 255, 255, .86) 78%, rgba(255, 248, 252, .96) 100%),
      linear-gradient(180deg, rgba(49, 24, 77, .04) 0%, rgba(49, 24, 77, .34) 100%);
  }

  .ce-hero-inner,
  .ce-hero-panel {
    text-align: center;
  }

  .ce-hero-copy,
  .ce-hero-subtitle {
    margin-left: auto;
    margin-right: auto;
  }

  .ce-hero-actions {
    justify-content: center;
  }

  .ce-hero-panel {
    width: 100%;
  }

  .ce-hero-title {
    font-size: clamp(54px, 18vw, 82px);
  }

  .ce-hero-subtitle {
    font-size: clamp(20px, 7vw, 30px);
  }

  .ce-hero-copy {
    display: none;
  }

  .ce-hero-meta {
    margin-top: 10px;
    font-size: 15px;
    line-height: 1.35;
  }

  .ce-details-grid,
  .ce-entourage-grid {
    grid-template-columns: 1fr;
  }

  .ce-cloud-card {
    --cloud-radius: 38px 52px 42px 56px / 48px 38px 54px 42px;
    --cloud-position: center;
  }

  .ce-detail:nth-child(even),
  .ce-entourage-card:nth-child(even),
  .ce-reminders {
    --cloud-radius: 54px 38px 58px 42px / 40px 56px 44px 52px;
  }

  .ce-countdown {
    --cloud-radius: 46px 62px 42px 58px / 56px 42px 62px 46px;
  }

  .ce-detail {
    align-items: center;
    text-align: center;
  }

  .ce-detail-icon {
    margin: 0 auto;
  }

  .ce-countdown-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
  }

  .ce-time-box {
    min-height: 76px;
    border-radius: 18px;
    padding: 10px 4px;
  }

  .ce-time-num {
    font-size: clamp(24px, 8vw, 32px);
  }

  .ce-time-label {
    font-size: 9px;
    letter-spacing: .08em;
  }

  .ce-glimpse-grid {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }

  .ce-glimpse-card,
  .ce-glimpse-tall,
  .ce-glimpse-wide {
    grid-column: auto;
    grid-row: auto;
    aspect-ratio: 4 / 5;
  }

  .ce-glimpse-wide {
    aspect-ratio: 16 / 10;
  }

  .ce-section {
    padding-top: 46px;
    padding-bottom: 46px;
  }

}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: .001ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
  }

  .ce-opening-particles {
    display: none;
  }
}
`;

function FloatingDecor() {
  const pieces = useMemo(() => {
    const shapes = [
      'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 92%, 50% 70%, 21% 92%, 32% 57%, 2% 35%, 39% 35%)',
      'polygon(50% 12%, 88% 50%, 50% 88%, 12% 50%)',
      'ellipse(50% 50% at 50% 50%)',
    ];
    const colors = ['#ff8dbc', '#ffd86e', '#9be6c6', '#8bd9ff', '#c7a1ff'];

    return Array.from({ length: 22 }, (_, index) => ({
      id: index,
      left: `${(index * 11.2 + 3) % 98}%`,
      top: `${(index * 17.6 + 7) % 96}%`,
      size: `${14 + ((index * 9) % 24)}px`,
      opacity: 0.16 + (index % 4) * 0.05,
      duration: `${5 + (index % 5)}s`,
      delay: `${(index % 7) * -0.45}s`,
      shape: shapes[index % shapes.length],
      color: colors[index % colors.length],
    }));
  }, []);

  return (
    <>
      {pieces.map((piece) => (
        <span
          key={piece.id}
          className="ce-float"
          style={{
            '--left': piece.left,
            '--top': piece.top,
            '--size': piece.size,
            '--opacity': piece.opacity,
            '--duration': piece.duration,
            '--delay': piece.delay,
            '--shape': piece.shape,
            '--color': piece.color,
          }}
        />
      ))}
    </>
  );
}

function OpeningParticles() {
  const particles = useMemo(() => {
    const shapes = [
      'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 92%, 50% 70%, 21% 92%, 32% 57%, 2% 35%, 39% 35%)',
      'polygon(50% 12%, 88% 50%, 50% 88%, 12% 50%)',
      'ellipse(50% 50% at 50% 50%)',
    ];
    const colors = ['#ff82b4', '#ffd86e', '#93e4c1', '#7fd6ff', '#b99bff'];

    return Array.from({ length: 16 }, (_, index) => ({
      id: index,
      left: `${8 + ((index * 17) % 86)}%`,
      size: `${8 + ((index * 5) % 13)}px`,
      color: colors[index % colors.length],
      shape: shapes[index % shapes.length],
      duration: `${8 + (index % 5)}s`,
      delay: `${index * -0.62}s`,
      drift: `${index % 2 === 0 ? '' : '-'}${18 + ((index * 7) % 34)}px`,
      opacity: 0.28 + (index % 3) * 0.1,
    }));
  }, []);

  return (
    <div className="ce-opening-particles" aria-hidden="true">
      {particles.map((particle) => (
        <span
          key={particle.id}
          className="ce-wish-particle"
          style={{
            '--left': particle.left,
            '--size': particle.size,
            '--color': particle.color,
            '--shape': particle.shape,
            '--duration': particle.duration,
            '--delay': particle.delay,
            '--drift': particle.drift,
            '--opacity': particle.opacity,
          }}
        />
      ))}
    </div>
  );
}

function getCountdown() {
  const diff = Math.max(0, EVENT_DATE.getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return { days, hours, minutes, seconds };
}

export default function ClaudiaEvePolidario7thBirthday() {
  const audioRef = useRef(null);
  const [opened, setOpened] = useState(false);
  const [openingOut, setOpeningOut] = useState(false);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [countdown, setCountdown] = useState(getCountdown);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    try {
      if (import.meta.env && import.meta.env.MODE !== 'development') return;
      if (!INVITATION_ID) return;
      const endpoint =
        (import.meta.env.VITE_API_BASE_URL || '') +
        '/internal/dev/invitations/' +
        encodeURIComponent(INVITATION_ID) +
        '/auto-integrate';
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ environment: 'local' }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (!json || !json.ok) console.warn('Dev auto-integrate failed', json);
        })
        .catch(() => {});
    } catch {
      // Development helper only.
    }
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => setCountdown(getCountdown()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!selectedPhoto) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setSelectedPhoto(null);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedPhoto]);

  const openInvitation = () => {
    setOpeningOut(true);
    window.setTimeout(() => {
      setOpened(true);
      const audio = audioRef.current;
      if (audio) {
        audio.volume = 0.48;
        audio.play().then(() => setMusicPlaying(true)).catch(() => setMusicPlaying(false));
      }
    }, 560);
  };

  const closeInvitation = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    setMusicPlaying(false);
    setOpened(false);
    setOpeningOut(false);
  };

  const toggleMusic = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (musicPlaying) {
      audio.pause();
      setMusicPlaying(false);
      return;
    }

    audio.play().then(() => setMusicPlaying(true)).catch(() => setMusicPlaying(false));
  };

  const countItems = [
    { label: 'Days', value: countdown.days },
    { label: 'Hours', value: countdown.hours },
    { label: 'Mins', value: countdown.minutes },
    { label: 'Secs', value: countdown.seconds },
  ];

  return (
    <>
      <style>{CSS}</style>
      <audio ref={audioRef} src={bgMusic} loop preload="auto" />

      {!opened && (
        <div className={`ce-opening${openingOut ? ' is-leaving' : ''}`}>
          <OpeningParticles />
          <div className="ce-opening-card">
            <h1 className="ce-opening-title">Claudia Eve</h1>
            <p className="ce-opening-sub">7th Birthday Celebration</p>
            <button className="ce-btn" type="button" onClick={openInvitation}>
              Open Invitation
            </button>
          </div>
        </div>
      )}

      {opened && (
        <main className="ce-page">
          <FloatingDecor />
          <div className="ce-music" role="region" aria-label="Invitation controls">
            <button
              className="ce-icon-btn"
              type="button"
              onClick={toggleMusic}
              aria-label={musicPlaying ? 'Pause music' : 'Play music'}
              title={musicPlaying ? 'Pause music' : 'Play music'}
            >
              {musicPlaying ? <FiPause aria-hidden="true" /> : <FiPlay aria-hidden="true" />}
            </button>
            <button
              className="ce-icon-btn"
              type="button"
              onClick={closeInvitation}
              aria-label="Close invitation"
              title="Close invitation"
            >
              <FiX aria-hidden="true" />
            </button>
          </div>

          <div className="ce-shell">
            <header className="ce-hero">
              <picture className="ce-hero-bg" aria-hidden="true">
                <source media="(max-width: 680px)" srcSet={celebrantCoverMobile} />
                <img src={celebrantCover} alt="" loading="eager" decoding="async" />
              </picture>

              <div className="ce-hero-inner">
                <section className="ce-hero-panel" aria-labelledby="claudia-title">
                  <p className="ce-eyebrow">You are invited to celebrate</p>
                  <h1 id="claudia-title" className="ce-hero-title">
                    Claudia <span>Eve</span>
                  </h1>
                  <p className="ce-hero-subtitle">7th Birthday Celebration</p>
                  <p className="ce-hero-copy">
                    A sweet pastel-rainbow afternoon filled with wishes and magical memories.
                  </p>
                </section>

                <p className="ce-hero-meta" aria-label="Event summary">
                  {EVENT_DATE_LABEL} <span aria-hidden="true">|</span> {EVENT_TIME_LABEL}{' '}
                  <span aria-hidden="true">|</span> {VENUE_NAME}
                </p>
              </div>
            </header>

            <section className="ce-section">
              <div className="ce-section-head">
                <p className="ce-section-kicker">Birthday Details</p>
                <h2 className="ce-section-title">A Rainbow Day For Claudia Eve</h2>
                <p className="ce-section-copy">
                  Kindly join us as Claudia Eve turns seven. Your presence will make her
                  celebration brighter, softer, and even more memorable.
                </p>
              </div>

              <div className="ce-details-grid">
                <article className="ce-detail ce-cloud-card">
                  <div>
                    <p className="ce-detail-label">Celebrant</p>
                    <p className="ce-detail-value">Claudia Eve</p>
                    <p className="ce-detail-note">Our pastel rainbow birthday girl</p>
                  </div>
                </article>

                <article className="ce-detail ce-cloud-card">
                  <div>
                    <p className="ce-detail-label">Date</p>
                    <p className="ce-detail-value">{EVENT_DATE_LABEL}</p>
                    <p className="ce-detail-note">Please save the date</p>
                  </div>
                </article>

                <article className="ce-detail ce-cloud-card">
                  <div>
                    <p className="ce-detail-label">Arrival</p>
                    <p className="ce-detail-value">{EVENT_TIME_LABEL}</p>
                    <p className="ce-detail-note">Guests are requested to arrive on time</p>
                  </div>
                </article>

                <article className="ce-detail ce-cloud-card">
                  <div>
                    <p className="ce-detail-label">Venue</p>
                    <p className="ce-detail-value">{VENUE_NAME}</p>
                    <p className="ce-detail-note">{VENUE_ADDRESS}</p>
                  </div>
                </article>
              </div>
            </section>

            <section className="ce-section">
              <div className="ce-countdown ce-cloud-card">
                <div>
                  <p className="ce-section-kicker">Countdown</p>
                  <h2 className="ce-countdown-title">Until Claudia Eve's Big Day</h2>
                  <p className="ce-countdown-text">
                    The rainbow road is getting closer. We cannot wait to celebrate
                    with everyone at {VENUE_NAME}.
                  </p>
                </div>
                <div className="ce-countdown-grid" aria-label="Countdown timer">
                  {countItems.map((item) => (
                    <div className="ce-time-box" key={item.label}>
                      <span className="ce-time-num">{String(item.value).padStart(2, '0')}</span>
                      <span className="ce-time-label">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="ce-section">
              <div className="ce-venue">
                <article className="ce-venue-card ce-cloud-card">
                  <p className="ce-section-kicker">Where The Magic Happens</p>
                  <img src={venuePhoto} alt="Photo of the venue" loading="lazy" decoding="async" />
                  <h2 className="ce-venue-name">{VENUE_NAME}</h2>
                  <p className="ce-venue-address">
                    <FiMapPin aria-hidden="true" /> {VENUE_ADDRESS}
                  </p>
                  <p className="ce-venue-body">
                    Food, laughter, games, candles, wishes, treasures, flowers, and
                    lots of pastel rainbow moments are waiting for Claudia Eve's guests.
                  </p>
                  <div className="ce-swatch-row" aria-label="Dress code colors">
                    <span className="ce-swatch" style={{ '--swatch': '#ffd5e5' }}>Pastel Pink</span>
                    <span className="ce-swatch" style={{ '--swatch': '#d9d1ff' }}>Lavender</span>
                    <span className="ce-swatch" style={{ '--swatch': '#c9edff' }}>Baby Blue</span>
                    <span className="ce-swatch" style={{ '--swatch': '#fff0a8' }}>Soft Yellow</span>
                    <span className="ce-swatch" style={{ '--swatch': '#cef6dd' }}>Mint</span>
                  </div>
                  <div className="ce-hero-actions" style={{ justifyContent: 'flex-start' }}>
                    <a className="ce-btn" href={VENUE_MAP_URL} target="_blank" rel="noopener noreferrer">
                      <FiMapPin aria-hidden="true" />
                      Open Map
                    </a>
                  </div>
                </article>

                <aside className="ce-reminders ce-cloud-card" aria-labelledby="reminder-title">
                  <div>
                    <p className="ce-section-kicker">Guest Notes</p>
                    <h2 id="reminder-title" className="ce-section-title">Reminders</h2>
                  </div>
                  {reminders.map((reminder) => (
                    <article className="ce-reminder" key={reminder.title}>
                      <h3>{reminder.title}</h3>
                      <p>{reminder.text}</p>
                    </article>
                  ))}
                </aside>
              </div>
            </section>

            <section className="ce-section">
              <div className="ce-section-head">
                <p className="ce-section-kicker">Glimpse</p>
                <h2 className="ce-section-title">Sweet Moments With Claudia Eve</h2>
                <p className="ce-section-copy">
                  A little preview of our birthday girl in soft pastels, flowers,
                  and the cheerful rainbow theme she loves.
                </p>
              </div>

              <div className="ce-glimpse-grid">
                {glimpsePhotos.map((photo) => (
                  <figure
                    className={`ce-glimpse-card ${photo.className}`}
                    key={photo.src}
                    role="button"
                    tabIndex={0}
                    aria-label={`View larger photo: ${photo.alt}`}
                    onClick={() => setSelectedPhoto(photo)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setSelectedPhoto(photo);
                      }
                    }}
                  >
                    <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" />
                  </figure>
                ))}
              </div>
            </section>

            {selectedPhoto && (
              <div
                className="ce-photo-viewer"
                role="dialog"
                aria-modal="true"
                aria-label="Expanded celebrant photo"
                onClick={() => setSelectedPhoto(null)}
              >
                <figure className="ce-photo-viewer-card" onClick={(event) => event.stopPropagation()}>
                  <button
                    className="ce-icon-btn ce-photo-viewer-close"
                    type="button"
                    onClick={() => setSelectedPhoto(null)}
                    aria-label="Close photo"
                    title="Close photo"
                  >
                    <FiX aria-hidden="true" />
                  </button>
                  <img src={selectedPhoto.src} alt={selectedPhoto.alt} />
                </figure>
              </div>
            )}

            <section className="ce-section">
              <div className="ce-section-head">
                <p className="ce-section-kicker">Birthday Program</p>
                <h2 className="ce-section-title">Seven Sweet Traditions</h2>
                <p className="ce-section-copy">
                  A special part of Claudia Eve's seventh birthday will be shared
                  with family and friends chosen for these meaningful moments.
                </p>
              </div>

              <div className="ce-entourage-grid">
                {entourageGroups.map((group) => (
                  <article className="ce-entourage-card ce-cloud-card" key={group.title}>
                    <h3>{group.title}</h3>
                    <p>{group.note}</p>
                    <ol className="ce-name-list">
                      {group.names.map((name) => (
                        <li key={name}>{name}</li>
                      ))}
                    </ol>
                  </article>
                ))}
              </div>
            </section>

            <footer className="ce-footer">
              <p>
                With love, <strong>Claudia Eve's Family</strong>
              </p>
              <p>
                <FiMusic aria-hidden="true" /> Pastel rainbow celebration music
              </p>
              <p>
                <FiUsers aria-hidden="true" /> Dress code: pastel colors only, no dark colors
              </p>
              <p>
                <FiGift aria-hidden="true" /> {INVITATION_TITLE}
              </p>
              <div className="ce-logica-credit">
                <p>
                  Created with <span className="ce-logica-heart" aria-hidden="true">♥</span> by
                </p>
                <a
                  className="ce-logica-brand"
                  href="https://logicatechnology.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Logica Technology"
                >
                  <img src={logicaLogo} alt="" aria-hidden="true" />
                  <span>Logica Technology</span>
                </a>
              </div>
            </footer>
          </div>
        </main>
      )}
    </>
  );
}
